import React, { createContext, useContext } from 'react'
import { DEFAULT_BRAND, getBrand } from 'brands'

// The host's brand, resolved once per request on the server and handed to the client
// through window.env.BRAND (src/server.js), so both render the same thing.
const BrandContext = createContext(getBrand(DEFAULT_BRAND))

export const BrandProvider = ({ brandKey, children }) => (
  <BrandContext.Provider value={getBrand(brandKey)}>
    {children}
  </BrandContext.Provider>
)

export const useBrand = () => useContext(BrandContext)

export default BrandContext
